export default __webpack_public_path__ + "static/0146-797b32d2d0a4ed7d11b1b4d5f86f4b71.png";